import { z } from "zod";

const today = new Date();
today.setHours(0, 0, 0, 0);

const requiredString = (message) =>
  z.preprocess((value) => value ?? "", z.string().trim().min(1, message));

const requiredSelect = (message, placeholder) =>
  requiredString(message).refine((v) => v !== placeholder, message);

export const NO_DISTRICT_VALUE = "__NO_DISTRICT__";

const participantsSchema = z.preprocess(
  (value) => (value === "" || value == null ? undefined : Number(value)),
  z
    .number({
      error: (issue) =>
        issue.input === undefined
          ? "No. of participants is required"
          : "Must be a number",
    })
    .int("Participants must be a whole number")
    .min(1, "At least 1 participant required"),
);

export const bookingSchemaFields = {
  cluster: requiredString("Please select a cluster").refine(
    (v) => v !== "Select Cluster",
    "Please select a cluster",
  ),

  venue: requiredString("Please select a venue").refine(
    (v) => v !== "Select Venue",
    "Please select a venue",
  ),

  sport: requiredString("Please select a sport").refine(
    (v) => v !== "Select Sport",
    "Please select a sport",
  ),

  bookingDate: requiredString("Please pick a date").refine((v) => {
    const picked = new Date(v);
    return picked >= today;
  }, "Date must be today or in the future"),

  zone: requiredString("Please select a zone").refine(
    (v) => v !== "Select Zone",
    "Please select a zone",
  ),

  timeSlot: requiredString("Please select a time slot").refine(
    (v) => v !== "Select Available Slot",
    "Please select a time slot",
  ),

  participants: participantsSchema,
};

export const existingUserBookingSchema = z.object(bookingSchemaFields);

export const guestBookingSchema = z.object({
  fullName: requiredString("Full name is required")
    .refine(
      (v) => v.trim().length >= 2,
      "Full name must be at least 2 characters",
    )
    .refine(
      (v) => v.trim().length <= 30,
      "Full name must be at most 30 characters",
    )
    .refine(
      (v) => /^[A-Za-z\s]+$/.test(v),
      "Full name should contain only alphabets and spaces",
    )
    .refine((v) => !/\d/.test(v), "Full name cannot contain numbers"),
  mobileNumber: requiredString("Mobile number is required").refine(
    (v) => /^[6-9][0-9]{9}$/.test(v),
    "Enter a valid mobile number",
  ),
  gender: requiredSelect("Please select a gender", "Select Gender"),
  state: requiredSelect("Please select a state", "Select State"),
  district: requiredString("Please select a district").transform((value) =>
    value === NO_DISTRICT_VALUE ? null : value,
  ),
  ...bookingSchemaFields,
});
